import {observer} from "mobx-react";
import {
    Container,
    Content, ContentDescription, ContentIcon, ContentSubTitle, TextBold,
    Text
} from "@dropDesk/presentation/pages/subscription/ui/modals/pay_success/styled";
import HeaderModal from "@dropDesk/presentation/components/headers/header_modal";
import React from "react";
import {useBetween} from "use-between";
import {useModalsSubscription} from "@dropDesk/presentation/pages/subscription/ui/modals/visible_modal_subscription";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import {PlanExtensionSimulateHireEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_simulate_hire.entity";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import {formatDateToDDMMYYYY} from "@dropDesk/utils/helpers/date_helper";

const ExtensionTrialSuccess = observer(({simulate}: { simulate: PlanExtensionSimulateHireEntity }) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    const {setVisibleModalExtensionTrialSuccess} = useBetween(useModalsSubscription);

    return (
        <Container>
            <HeaderModal
                disabled={false}
                letter={'Extensão ativada'}
                nameIcon={ICONS_DROPDESK.close}
                onClick={() => setVisibleModalExtensionTrialSuccess({visible: false, simulate: null})}
            />
            <Content background={colors.onBackground}>
                <ContentIcon>
                    <DropDeskIcon icon={ICONS_DROPDESK.check} size={130} color={colors.success}/>
                </ContentIcon>

                <ContentSubTitle>
                    <TextBold size={20} color={colors.success}>Extensão ativada com sucesso!</TextBold>
                </ContentSubTitle>

                <ContentDescription>
                    <Text size={15} color={colors.text} style={{textAlign: 'center', lineHeight: 1.6}}>
                        Você tem <TextBold size={15} color={colors.text}>{simulate.trialDaysApplied} dias gratuitos</TextBold> para experimentar a extensão.
                        {'\n\n'}
                        Uma cobrança de <TextBold size={15} color={colors.text}>{formatCurrency(simulate.firstCycleValue)}</TextBold> foi gerada com vencimento em <TextBold size={15} color={colors.text}>{formatDateToDDMMYYYY(new Date(simulate.paymentDueDate))}</TextBold>.
                        Se cancelar a extensão antes disso, não será cobrado nada.
                    </Text>
                </ContentDescription>
            </Content>
        </Container>
    );
});

export default ExtensionTrialSuccess;
